import { PdfInfo } from "../Models/Pdf/PdfInfo";
import { AjaxService } from "../Helpers/AjaxService"
export class ContractApi {
    private static instance: ContractApi;
    static getInstance() { return ContractApi.instance || (ContractApi.instance = new ContractApi()); }

    getContracts() {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/Contract/GetContracts`;
        return new Promise<PdfInfo[]>((resolve) => {
            ajaxService.get(apiUrl,
                (result: PdfInfo[]) => {
                    result.forEach(pdfInfo => {
                        if (pdfInfo.PrintDate)
                            pdfInfo.PrintDate = this.getDateString(new Date(parseInt(pdfInfo.PrintDate.substr(6))));
                        if (pdfInfo.ReceivedDate)
                            pdfInfo.ReceivedDate = this.getDateString(new Date(parseInt(pdfInfo.ReceivedDate.substr(6))));
                        if (pdfInfo.SignedDate) {
                            pdfInfo.SignedDate = this.getDateString(new Date(parseInt(pdfInfo.SignedDate.substr(6))));
                            pdfInfo.Signed = true;
                        }
                        if (pdfInfo.DateAndTime)
                            pdfInfo.DateAndTime = new Date(parseInt(pdfInfo.DateAndTime.toString().substr(6)));
                        else {
                            pdfInfo.Signed = false;
                        }
                    });
                    resolve(result);
                });
        });
    }

    private getDateString(date: Date): any {
        let mm = ("0" + (date.getMonth() + 1)).slice(-2);
        let dd = ("0" + date.getDate()).slice(-2);
        let yyyy = date.getFullYear();
        if (yyyy > 1900)
            return `${dd}-${mm}-${yyyy}`;
        else
            return "";
    }
}